import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PushPipe } from '@ngrx/component';
import { FormFiltersModule } from '../../../shared/features/form-filters/form-filters.module';
import { ViewShellComponent } from './view-shell.component';

@NgModule({
    imports: [CommonModule, FormFiltersModule, PushPipe],
    declarations: [ViewShellComponent],
    exports: [ViewShellComponent],
})
export class ViewShellModule {}
